<template>
  <div id="error-layout">
      ERROR LAYOUT
      <slot></slot>
  </div>
</template>

<script>
export default {

};
</script>

<style lang="scss">

</style>